import { ResponsiveProvider } from './../providers/responsive/responsive';
import { FbConfig } from './FbConfig';
import { TranslateService } from '@ngx-translate/core';
import { ResponseContentType, Http, Response } from '@angular/http';
import { FbTipsterInfo } from '../model/FbTipsterInfo';
import { FbTipsPackageDetails } from '../model/FbTipsPackageDetails';
import { FbPackageTip } from '../model/FbPackageTip';
import { FbBetModel } from '../model/FbBetModel';
import { FbMatch } from '../model/FbMatch';
import { FbTipPrice } from '../model/FbTipPrice';
import { FbNotes } from '../model/FbNotes';
import { FbPersonalTipsPackage } from '../model/FbPersonalTipsPackage';
import { Constants, ShareType, RaceTrack, RaceCourse } from './Constants';
import { Platform, AlertController, NavController, ActionSheetController } from 'ionic-angular';
import { HorseRaceModel } from '../model/horse/HorseRaceModel';
import { SocialSharing } from '@ionic-native/social-sharing';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { BrowserTab } from '@ionic-native/browser-tab';

import * as Enums from './enums';

declare var CryptoJS: any;

import { AppVersion } from '@ionic-native/app-version';
import { ThemeableBrowserOptions, ThemeableBrowser } from '@ionic-native/themeable-browser';
import { Observable } from 'rxjs/Observable';
import { CustomStorageProvider } from '../providers/custom-storage/custom-storage';
import { UserManagerProvider } from '../providers/user-manager/user-manager';
import { LoadingCtrlProvider } from '../providers/loading-ctrl/loading-ctrl';
import { AppAvailability } from '@ionic-native/app-availability';
import { Market } from '@ionic-native/market';
import { RaceCourseDisplayed } from '../model/RaceCourseDisplayed';

export class Util {

  public static getPredictionUrl() {
    if (FbConfig.DEBUG) {
      return "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/tc/showVideo.do";
    } else {
      return "https://www.kintips.com/tc/showVideo.do";
    }
  }

  public static getHostImage(tipsterId: number) {
    if (FbConfig.DEBUG) {
      return "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/img/common/tipster" + tipsterId + ".jpg?t=" + new Date().getTime();
    } else {
      return "https://www.kintips.com/img/common/tipster" + tipsterId + ".jpg?t=" + new Date().getTime();
    }
  }

  public static getHostBanner(tipsterId: number) {
    if (FbConfig.DEBUG) {
      return "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/video/tipster" + tipsterId + ".jpg?t=" + new Date().getTime();
      //return "https://cdn.kintips.com:" + FbConfig.PRD_HTTPS_PORT + "/iads/images/" + imageType + "/" + imageId + ".jpg";
    } else {
      return "https://cdn.kintips.com:" + FbConfig.PRD_HTTPS_PORT + "/video/tipster" + tipsterId + ".jpg?t=" + new Date().getTime();
    }
  }

  public static getBanner(bannerUrl: string) {
    if (FbConfig.DEBUG) {
      return "http:" + bannerUrl;
    } else {
      return "https:" + bannerUrl;
    }
  }

  public static getImgUrl(imageType: number, imageId: number, imgTime: string = "") {
    let imgUrl = "";
    if (FbConfig.DEBUG) {
      imgUrl = "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/iads/images/" + imageType + "/" + imageId;
      // return "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/iads/images/" + imageType + "/" + imageId + "_" + imgTime + ".jpg";
      //return "https://cdn.kintips.com:" + FbConfig.PRD_HTTPS_PORT + "/iads/images/" + imageType + "/" + imageId + ".jpg";
    } else {
      // imgUrl = "https://cdn.kintips.com:" + FbConfig.PRD_HTTPS_PORT + "/iads/images/" + imageType + "/" + imageId;
      imgUrl = "https://s3.kintips.com/iads/images/" + imageType + "/" + imageId;
      // return "https://cdn.kintips.com:" + FbConfig.PRD_HTTPS_PORT + "/iads/images/" + imageType + "/" + imageId + "_" + imgTime + ".jpg";
      // return "https://i001.onahsay.com:" + FbConfig.PRD_HTTPS_PORT + "/iads/images/" + imageType + "/" + imageId + ".jpg";
    }
    if (imageType == Constants.Enum_ImageType.indexOf("TipsPackageImage1") || imageType == Constants.Enum_ImageType.indexOf("TipsPackageImage2")
        || imageType == Constants.Enum_ImageType.indexOf("TipsPackageImage3")) {
      imgUrl += "_" + imgTime + ".jpg";
    } else {
      imgUrl += ".jpg";
    }
    return imgUrl;
  }

  public static getActualNumber(num: number) {
    return Number((num / 100).toFixed(2));
  }

  public static getOddsActualNumber(num: number) {
    return Number((num / 10).toFixed(2));
  }

  public static getActualNumberWithMinusOne(num: number) {
    return num == -1 ? num : this.getActualNumber(num);
  }

  public static getMultipliedNumber(num: number) {
    return Number((num * 100).toFixed(0));
  }

  public static convertWinningMargin(sWinningMargin: String) {
    if (sWinningMargin.indexOf("+") != -1) {
      let re = /\+/gi;
      return sWinningMargin.replace(re, "-");
    } else {
      let re = /\-/gi;
      return sWinningMargin.replace(re, "+");
    }
  }

  public static getWeekday(iWeekDay: number, translateService: TranslateService): string {
    if (iWeekDay == 1) {
      return translateService.instant("sunday");
    } else if (iWeekDay == 2) {
      return translateService.instant("monday");
    } else if (iWeekDay == 3) {
      return translateService.instant("tuesday");
    } else if (iWeekDay == 4) {
      return translateService.instant("wednesday");
    } else if (iWeekDay == 5) {
      return translateService.instant("thursday");
    } else if (iWeekDay == 6) {
      return translateService.instant("friday");
    } else if (iWeekDay == 7) {
      return translateService.instant("saturday");
    }
  }

  public static getScore(score: number): string {
    return (score < 0) ? "--" : String(score);
  }

  public static getMatchTime(sMatchTime: string) {
    return (sMatchTime.length > 5) ? sMatchTime.substring(0, 5) : sMatchTime;
  }

  public static getMatchProgress(iMatchProg: number, sStartTime: string, iCurrentMin: number, translateService: TranslateService) {
    if (iMatchProg == 0) {
      return Util.getMatchTime(sStartTime);
    } else if (iMatchProg == 1) {
      if (iCurrentMin == -1) {
        return translateService.instant("firstHalf");
      }
      return iCurrentMin >= 45 ? "45' + " + (iCurrentMin - 45) + "'" : iCurrentMin + "'";
    } else if (iMatchProg == 2) {
      return translateService.instant("halfTime");
    } else if (iMatchProg == 3) {
      if (iCurrentMin == -1) {
        return translateService.instant("secondHalf");
      }
      return iCurrentMin >= 90 ? "90' + " + (iCurrentMin - 90) + "'" : iCurrentMin + "'";
    } else if (iMatchProg == 4) {
      return translateService.instant("fullTime");
    } else if (iMatchProg == 5) {
      return translateService.instant("started");
    } else if (iMatchProg == 6) {
      return translateService.instant("voided");
    } else if (iMatchProg == 7) {
      return translateService.instant("postponed");
    }
  }

  public static getMatchStatus(iMatchProg: number, translateService: TranslateService) {
    if (iMatchProg == 0) {
      return translateService.instant("notStarted");
    } else if (iMatchProg == 1 || iMatchProg == 2 || iMatchProg == 3 || iMatchProg == 5) {
      return translateService.instant("started");
    } else if (iMatchProg == 4) {
      return translateService.instant("fullTimeAlready");
    } else if (iMatchProg == 6) {
      return translateService.instant("voided");
    } else if (iMatchProg == 7) {
      return translateService.instant("postponed");
    }
  }

  public static getMatchDetailsPageTitle(dayOfWeek: number, matchNum, translateService: TranslateService) {
    if (matchNum == 0 || Util.getWeekday(dayOfWeek, translateService) == null) {
      return "";
    } else {
      return translateService.instant("match") + " " + Util.getWeekday(dayOfWeek, translateService) + " " + matchNum;
    }
  }

  public static escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
  }

  public static replaceAll(str, find, replace) {
    return str.replace(new RegExp(Util.escapeRegExp(find), 'g'), replace);
  }

  public static goToKintipsPage(pageName) {
    window.location.href = this.getKintipsUrl() + "#/" + pageName;
  }

  public static getConvertedRanking(ranking: string): string {
    let convertedRanking: string;
    if (ranking == "999999" || ranking == "99999999") {
      convertedRanking = "--";
    } else {
      convertedRanking = ranking;
    }
    return convertedRanking;
  }

  public static getEmojiImageUrl(profitMargin) {
    let emojiUrl;
    if (profitMargin == "") {
      emojiUrl = "assets/img/horse/hrtn-emoji.png";
    } else if (profitMargin > 1500) {
      emojiUrl = "assets/img/horse/hrtn-emoji-level6.png";
    } else if (profitMargin > 800) {
      emojiUrl = "assets/img/horse/hrtn-emoji-level5.png";
    } else if (profitMargin > 250) {
      emojiUrl = "assets/img/horse/hrtn-emoji-level4.png";
    } else if (profitMargin >= 70) {
      emojiUrl = "assets/img/horse/hrtn-emoji-level3.png";
    } else if (profitMargin >= 0) {
      emojiUrl = "assets/img/horse/hrtn-emoji-level2.png";
    } else if (profitMargin > -100) {
      emojiUrl = "assets/img/horse/hrtn-emoji-level1.png";
    } else {
      emojiUrl = "assets/img/horse/hrtn-emoji-level0.png";
    }

    return emojiUrl;
  }

  public static getEmojiSvgUrl(profitMargin, isOptOut) {
    let emojiUrl;
    if (profitMargin == "") {
      emojiUrl = "assets/img/horse/hrtn-emoji-level-s.svg";
    } else if (profitMargin > 1500) {
      if (isOptOut) {
        emojiUrl = "assets/img/horse/hrtn-emoji-level6-g.svg";
      } else {
        emojiUrl = "assets/img/horse/hrtn-emoji-level6.svg";
      }
    } else if (profitMargin > 800) {
      if (isOptOut) {
        emojiUrl = "assets/img/horse/hrtn-emoji-level5-g.svg";
      } else {
        emojiUrl = "assets/img/horse/hrtn-emoji-level5.svg";
      }
    } else if (profitMargin > 250) {
      if (isOptOut) {
        emojiUrl = "assets/img/horse/hrtn-emoji-level4-g.svg";
      } else {
        emojiUrl = "assets/img/horse/hrtn-emoji-level4.svg";
      }
    } else if (profitMargin >= 70) {
      if (isOptOut) {
        emojiUrl = "assets/img/horse/hrtn-emoji-level3-g.svg";
      } else {
        emojiUrl = "assets/img/horse/hrtn-emoji-level3.svg";
      }
    } else if (profitMargin >= 0) {
      if (isOptOut) {
        emojiUrl = "assets/img/horse/hrtn-emoji-level2-g.svg";
      } else {
        emojiUrl = "assets/img/horse/hrtn-emoji-level2.svg";
      }
    } else if (profitMargin > -100) {
      if (isOptOut) {
        emojiUrl = "assets/img/horse/hrtn-emoji-level1-g.svg";
      } else {
        emojiUrl = "assets/img/horse/hrtn-emoji-level1.svg";
      }
    } else {
      if (isOptOut) {
        emojiUrl = "assets/img/horse/hrtn-emoji-level0-g.svg";
      } else {
        emojiUrl = "assets/img/horse/hrtn-emoji-level0.svg";
      }

    }

    return emojiUrl;
  }

  public static getArrowImgUrl(profitMargin) {
    let arrowImgUrl;
    if (profitMargin == "") {
      arrowImgUrl = "";
    } else if (profitMargin > 1500) {
      arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_upL.png";
    } else if (profitMargin > 800) {
      arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up.png";
    } else if (profitMargin > 250) {
      arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up.png";
    } else if (profitMargin >= 70) {
      arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_upS.png";
    } else if (profitMargin >= 0) {
      arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_mid.png";
    } else if (profitMargin > -100) {
      arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_downS.png";
    } else {
      arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_down.png";
    }

    return arrowImgUrl;
  }

  public static getArrowSvgUrl(profitMargin, isOptOut) {
    let arrowImgUrl;
    if (profitMargin == "") {
      arrowImgUrl = "";
    } else if (profitMargin > 1500) {
      if (isOptOut) {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up6-g.svg";
      } else {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up6.svg";
      }
    } else if (profitMargin > 800) {
      if (isOptOut) {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up5-g.svg";
      } else {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up5.svg";
      }
    } else if (profitMargin > 250) {
      if (isOptOut) {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up4-g.svg";
      } else {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up4.svg";
      }
    } else if (profitMargin >= 70) {
      if (isOptOut) {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up3-g.svg";
      } else {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up3.svg";
      }
    } else if (profitMargin >= 0) {
      if (isOptOut) {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up2-g.svg";
      } else {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up2.svg";
      }
    } else if (profitMargin > -100) {
      if (isOptOut) {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up1-g.svg";
      } else {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up1.svg";
      }
    } else {
      if (isOptOut) {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up0-g.svg";
      } else {
        arrowImgUrl = "assets/img/horse/hrtn-ico-arrow_up0.svg";
      }
    }

    return arrowImgUrl;
  }

  public static getProfitMarginClass(profitMargin) {
    let returnRateClass;
    if (profitMargin > 1500) {
      returnRateClass = "text-returnRate-5";
    } else if (profitMargin > 800) {
      returnRateClass = "text-returnRate-5";
    } else if (profitMargin > 250) {
      returnRateClass = "text-returnRate-5";
    } else if (profitMargin >= 70) {
      returnRateClass = "text-returnRate-4";
    } else if (profitMargin >= 0) {
      returnRateClass = "text-returnRate-3";
    } else if (profitMargin > -100) {
      returnRateClass = "text-returnRate-2";
    } else {
      returnRateClass = "text-returnRate-1";
    }

    return returnRateClass;
  }


  public static getProfileCap(tipsterScore, size) {
    let profileCap;
    if (tipsterScore >= 90) {
      if (size == "small") {
        profileCap = "assets/img/horse/pic-tag-6-god-list.png";
      } else {
        profileCap = "assets/img/horse/pic-tag-6-god.png";
      }
    } else if (tipsterScore >= 70) {
      if (size == "small") {
        profileCap = "assets/img/horse/pic-tag-5-king-list.png";
      } else {
        profileCap = "assets/img/horse/pic-tag-5-king.png";
      }
    } else if (tipsterScore >= 50) {
      if (size == "small") {
        profileCap = "assets/img/horse/pic-tag-4-master-list.png";
      } else {
        profileCap = "assets/img/horse/pic-tag-4-master.png";
      }
    } else if (tipsterScore >= Constants.TIPSTER_SCORE_WITH_EXPERT_CAP) {
      if (size == "small") {
        profileCap = "assets/img/horse/pic-tag-3-expert-list.png";
      } else {
        profileCap = "assets/img/horse/pic-tag-3-expert.png";
      }
    } else {
      if (size == "small") {
        profileCap = "assets/img/horse/pic-tag-2-amateur-list.png";
      } else {
        profileCap = "assets/img/horse/pic-tag-2-amateur.png";
      }
    }

    return profileCap;
  }

  public static getTipsPriceList(http: Http, tipScore: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let result = {};
      let resultTipsPriceList = new Array<any>();
      let resultTipsPackagePriceList = new Array<any>();
      http.get(this.getFbPriceListUrl()).toPromise().then(priceList => {
        let tipsPriceList = priceList.json().tipsPrice[Util.getRankingLevel(tipScore) - 2];
        for (let tipsPrice of tipsPriceList) {
          resultTipsPriceList.push({
            value: tipsPrice.value,
            label: tipsPrice.label,
          });
        }
        result["tipsPrice"] = resultTipsPriceList;
        let packagePriceList = priceList.json().tipsPackagePrice[Util.getRankingLevel(tipScore) - 2];
        for (let packagePrice of packagePriceList) {
          resultTipsPackagePriceList.push({
            value: packagePrice.value,
            label: packagePrice.label,
          });
        }
        result["tipsPackagePrice"] = resultTipsPackagePriceList;
        resolve(result);
      }, err => {
        console.log(err);
        reject(err);
      });
    });
  }

  public static getRankingLevel(tipsterScore) {
    let rankingLevel;
    if (tipsterScore >= 90) {
      rankingLevel = 6;
    } else if (tipsterScore >= 70) {
      rankingLevel = 5;
    } else if (tipsterScore >= 50) {
      rankingLevel = 4;
    } else if (tipsterScore >= 25) {
      rankingLevel = 3;
    } else {
      rankingLevel = 2;
    }
    return rankingLevel;
  }

  public static convertStringToDate(dateInString) {
    // console.log(dateInString);
    var regEx = /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/g;
    var match = regEx.exec(dateInString);
    var year = parseInt(match[1], 10);
    var month = parseInt(match[2], 10) - 1;
    var day = parseInt(match[3], 10);
    var hour = parseInt(match[4], 10);
    var min = parseInt(match[5], 10);
    var second = parseInt(match[6], 10);
    var resultDate = new Date(year, month, day, hour, min, second);
    /* resultDate.setFullYear(year);
    resultDate.setMonth(month);
    resultDate.setDate(day);
    resultDate.setHours(hour, min, second); */
    return resultDate;
  }

  public static getTimeDiff(date1, date2) {
    let a = new Date(date1).getTime(),
      b = new Date(date2).getTime(),
      diff: any = {};

    var diffMilliseconds = a > b ? a % b : b % a;
    var remainingSeconds = Math.ceil(diffMilliseconds / 1000);
    // console.log(remainingSeconds);
    //diff.days =  Math.floor(remainingSeconds / 60 / 60 / 24);
    //remainingSeconds -= diff.days * 60 * 60 * 24;
    // console.log("Day : " + diff.days + ", " + remainingSeconds);
    diff.hours = Math.floor(remainingSeconds / 60 / 60);
    remainingSeconds -= diff.hours * 60 * 60;
    diff.minutes = Math.floor(remainingSeconds / 60);
    diff.seconds = remainingSeconds - (diff.minutes * 60);

    return diff;
  }

  public static lpad(value, padding) {
    var zeroes = new Array(padding + 1).join("0");
    return (zeroes + value).slice(-padding);
  }

  public static getUpgradeStatus(serverVersion, clientVersion) {
    var serverFirstVersionDigit = parseInt(serverVersion.split(".")[0], 10);
    var serverSecondVersionDigit = parseInt(serverVersion.split(".")[1], 10);
    // var serverThirdVersionDigit = serverVersion.split(".")[2];

    var appFirstVersionDigit = parseInt(clientVersion.split(".")[0], 10);
    var appSecondVersionDigit = parseInt(clientVersion.split(".")[1], 10);
    // var appThirdVersionDigit = Constants.VERSION.split(".")[2];

    var serverNormalizedVersion = parseInt(this.getNormalizedVersion(serverVersion) + "", 10);
    //var appNormalizedVersion = this.getNormalizedVersion(Constants.VERSION);
    var appNormalizedVersion = parseInt(this.getNormalizedVersion(clientVersion) + "", 10);

    if (appNormalizedVersion > serverNormalizedVersion) {
      return "pending";
    } else if (serverFirstVersionDigit > appFirstVersionDigit) {
      return "major";
    } else {

      if (serverNormalizedVersion > appNormalizedVersion) {
        if (serverSecondVersionDigit > appSecondVersionDigit) {
          return "major";
        } else {
          return "minor";
        }
      } else {
        return "latest";
      }
    }
  }

  public static getNormalizedVersion(version) {
    var result = "";
    var versionArray = version.split(".");
    for (let i in versionArray) {
      var slicedVersion = versionArray[i];
      result += this.lpad(slicedVersion, 4);
    }

    return result;
  }

  public static getCurrentDateTime() {
    var now = new Date();

    var yyyy = now.getFullYear();

    var MM = (now.getMonth() + 1).toString(); // getMonth() is zero-based
    if (MM.length < 2) {
      MM = "0" + MM;
    }
    var dd = now.getDate().toString();
    if (dd.length < 2) {
      dd = "0" + dd;
    }
    var hh = now.getHours().toString();
    if (hh.length < 2) {
      hh = "0" + hh;
    }
    var mm = now.getMinutes().toString();
    if (mm.length < 2) {
      mm = "0" + mm;
    }

    var ss = now.getSeconds().toString();
    if (ss.length < 2) {
      ss = "0" + ss;
    }

    var result = yyyy + "-" + MM + "-" + dd + " " + hh + ":" + mm + ":" + ss;

    return result;
  }

  public static getServerUrl() {
    if (FbConfig.DEBUG) {
      return FbConfig.DEBUG_PROTOCOL + "://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/";
    } else {
      return FbConfig.PRD_PROTOCOL + "://" + FbConfig.PRD_IADS_HOSTNAME + ":" + FbConfig.PRD_HTTPS_PORT + "/";
    }
  }

  // Update to use USD pay url task #39895
  public static getUSDServerUrl() {
    if (FbConfig.DEBUG) {
      return FbConfig.DEBUG_PROTOCOL + "://" + FbConfig.DEBUG_USD_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/";
    } else {
      return FbConfig.PRD_PROTOCOL + "://" + FbConfig.PRD_USD_IADS_HOSTNAME + ":" + FbConfig.PRD_HTTPS_PORT + "/";
    }
  }

  public static getIadsBaseUrl() {
    return this.getServerUrl() + "iads";
  }

  public static getBankInPromotionUrl() {
    return this.getServerUrl() + "bankInPromotion.jsp";
  }

  public static getSharePageUrl() {
    return this.getServerUrl() + "sharePage.jsp";
  }

  public static getPrivacyTCPageUrl() {
    return this.getServerUrl() + "tncPage.jsp";
  }

  public static getRegBenefitPageUrl() {
    return this.getServerUrl() + "registerBenefits.jsp";
  }

  public static getBankInAmountListUrl() {
    return this.getServerUrl() + "bankInOptions.jsp";
  }

  public static getCreditCardAmountListUrl() {
    return this.getServerUrl() + "creditCardOptions.jsp";
  }

  public static getNoticeUrl(lang: string) {
    return this.getServerUrl() + "notice.jsp?lang=" + lang;
  }

  public static getKinboyPromotionUrl(lang: string, responsiveProvider: ResponsiveProvider) {
    let today = new Date();
    let isMobile = responsiveProvider.isMobile() ? "Y" : "N";
    let isKintips = "Y";
    let formattedToday = today.getFullYear() + "-" + (this.lpad(today.getMonth() + 1, 2)) + "-" + today.getDate();
    return this.getServerUrl() + "kinboyPromotionForKintips.jsp?lang=" + lang + "&t=" + formattedToday + "&mobile=" + isMobile + "&kintips=" + isKintips;
  }

  public static getEnablePredictionVideoUrl() {
    if (FbConfig.DEBUG) {
      return "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/settings/video.jsp?t=" + new Date().getTime();
    } else {
      return "https://cdn.kintips.com/settings/video.jsp?t=" + new Date().getTime();
    }
  }

  public static getAdBannerUrl(lang: string) {
    return this.getServerUrl() + "adb.jsp?lang=" + lang;
  }

  public static getAdDiscussionBannerUrl(lang: string) {
    return this.getServerUrl() + "ad/adDiscussion.jsp?lang=" + lang;
  }

  public static getAdBannerFilesUrl(fileName: string) {
    return this.getServerUrl() + "ad/" + fileName;
  }

  public static getKintipsIntroUrl(lang: string) {
    return this.getServerUrl() + "intro.jsp?lang=" + lang;
  }

  public static getMatchDate(sDate: string) {
    return sDate.substring(8, 10) + "/" + sDate.substring(5, 7);
  }

  public static getVersionUrl() {
    return this.getServerUrl() + "version.jsp";
  }

  public static getPriceListUrl() {
    return this.getServerUrl() + "/tipsPrice.jsp";
  }

  public static getFbPriceListUrl() {
    return this.getServerUrl() + "/fbTipsPrice.jsp";
  }

  static getKintipsUrl() {
    return this.getServerUrl() + "/m/index.html";
  }

  public static getMakeUnionPayUrl() {
    // Update to use USD pay url task #39895
    let url = this.getUSDServerUrl() + "iads/MakeUnionPayPayment.do"
    return url;
  }

  // Update to use USD pay url
  public static getMakeVisaMasterUrl() {
    // Update to use USD pay url task #39895
    // let url = this.getUSDServerUrl() + "iads/MakeMigs3dPayment.do"
    let url = this.getUSDServerUrl() + "iads/MakeMpgs3dPayment.do"
    return url;
  }

  public static getTutorialListUrl() {
    return this.getServerUrl() + "tutorial/tutorial.jsp";
  }

  public static getRewardTermsNConditions(name: string, lang: string) {
    return this.getServerUrl() + "rewardTermsNConditions.jsp?name=" + name + "&lang=" + lang;
  }


  public static getProAnalysisBannerUrl(lang: string) {
    return this.getServerUrl() + "video/adVideo.jsp?lang=" + lang;
  }

  public static getProFbAnalysisBannerUrl(lang: string) {
    return this.getServerUrl() + "video/adFbVideo.jsp?lang=" + lang;
  }

  public static getRadioUrl() {
    if (FbConfig.DEBUG) {
      return "http://192.168.22.41:61193/settings/radio.jsp";
    }
    return "https://iads001.kintips.com/settings/radio.jsp?t=" + new Date().valueOf();
  }

  public static getFbTipsterImage(tipsterId: number) {
    if (FbConfig.DEBUG) {
      return "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/video/fbTipster" + tipsterId + ".jpg?t=" + new Date().getTime();
    } else {
      return "https://iads001.kintips.com/video/fbTipster" + tipsterId + ".jpg?t=" + new Date().getTime();
    }
  }

  public static getFbMatchDate(time: string) {
    let month = time.substring(5,7);
    let date = time.substring(8,10);

    return date + "/" + month;
  }

  public static getFbMatchTime(time: string) {
    let startTime = time.substring(11, 16);

    return startTime;
  }

  public static convertTipsterInfoFromJson(tipsterInfoJson: any){
    if (tipsterInfoJson == null) {
      return new FbTipsterInfo(-1, "", -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, "", -1, false, false);
    } else {
      return new FbTipsterInfo(tipsterInfoJson.id, tipsterInfoJson.nickname,
        tipsterInfoJson.ranking, Util.getActualNumber(tipsterInfoJson.tipScore), tipsterInfoJson.profitability,
        Util.getActualNumber(tipsterInfoJson.accuracy), tipsterInfoJson.win, tipsterInfoJson.lose,
        tipsterInfoJson.subscribeType, tipsterInfoJson.accuracyRanking,
        tipsterInfoJson.profitabilityRanking, tipsterInfoJson.last7DaysAccuracyRanking,
        tipsterInfoJson.last7DaysProfitabilityRanking,
        Util.getActualNumber(tipsterInfoJson.profit),
        Util.getActualNumber(tipsterInfoJson.last7DaysProfit),
        tipsterInfoJson.profitRanking, tipsterInfoJson.last7DaysProfitRanking,
        tipsterInfoJson.last7DaysProfitability, tipsterInfoJson.last7DaysAccuracy,
        tipsterInfoJson.subscriberType, tipsterInfoJson.packageBuyerCount,
        Util.getActualNumber(tipsterInfoJson.betAmount), tipsterInfoJson.tipsPackagePrice,
        tipsterInfoJson.biographyDetail,
        Util.getActualNumber(tipsterInfoJson.highestScore), tipsterInfoJson.allowVoucherBuyPackage, tipsterInfoJson.allowTipsPackageRefund);
    }
  }

  public static shareToOtherSocialMedia(customStorageProvider: CustomStorageProvider, userManagerProvider: UserManagerProvider,
    platform: Platform, loadingCtrl: LoadingCtrlProvider, http: Http, socialSharing: SocialSharing,
    actionSheetCtrl: ActionSheetController, tipId: number) {
    let lang = customStorageProvider.get<string>(
      Constants.STORAGE_KEY_LANG
    );
    let loginUserId = userManagerProvider.getLoginUserId();
    let shareImgSrc = "";
    let shareMsg = "";
    if (Util.isApp(platform)) {
      loadingCtrl.createCmdLoading(Constants.LOADING_CTRL_CODE_GET_IMAGE);
      shareImgSrc = Util.getHorseInRaceShareImgUrl(tipId, lang, loginUserId);
      console.log("Share Image Src" + shareImgSrc);
      Util.getImageFromUrl(http, shareImgSrc).subscribe(data => {
        console.log("Share Image Date");
        console.log(data);
        Util.base64EncodeImageByCanvas(data).then(result => {
          loadingCtrl.dismissCmdLoading(Constants.LOADING_CTRL_CODE_GET_IMAGE);
          console.log("Share");
          Util.share(platform, socialSharing, actionSheetCtrl, result, shareMsg);
        }).catch(err => {
          loadingCtrl.dismissCmdLoading(Constants.LOADING_CTRL_CODE_GET_IMAGE);
          console.log(err);
        });
      },
      err => {
        console.log(err);
        loadingCtrl.dismissCmdLoading(Constants.LOADING_CTRL_CODE_GET_IMAGE);
      });
    } else {
      shareMsg = Util.getHorseInRaceShareImgUrl(
        tipId,
        lang,
        loginUserId
      );
      Util.share(
        platform,
        socialSharing,
        actionSheetCtrl,
        shareImgSrc,
        shareMsg
      );
    }
    //console.log(Util.createImageFromBlob(Util.getImageFromUrl(this.http, shareMsg)))
  }
  public static scroll2Div(sId: string) {
    let interval = setInterval(() => {
      let targetComment = document.getElementById("" + sId);
      if (targetComment != undefined) {
        // console.log(targetComment);
        // console.log(sId);
        clearInterval(interval);
        targetComment.scrollIntoView(true);
      }
    });
    return interval;
  }

  public static convertTipsPackageDetailsFromJson(result: any, fbTipsPackageDetails: FbTipsPackageDetails, loggedInUserId: number) {
    let tipsterInfoFromJson = result.tipsterInfo;
    let tipsPackageId = result.id;
    let betAmountQuota = Util.getActualNumber(result.betAmountQuota);
    let aMatches = result.match;
    let aMatchNum = new Array<number>();
    let aFbPackageTip = new Array<FbPackageTip>();
    let purchased = result.purchased;
    let purchaseDate = result.purchaseDate;
    let tipsPackagePrice = Util.getActualNumber(result.price);
    let totalBetAmount = Util.getActualNumber(result.betAmount);
    let curentBetAmount = Util.getActualNumber(result.currentBetAmount);
    let tipsPackageDividend = result.dividend != -1 ? Util.getActualNumber(result.dividend) : result.dividend;
    let buyerCount = result.buyerCount;
    let matchDayEnded = result.matchDayEnded;
    for (let match of aMatches) {
      let matchId = match.id;
      let matchDate = match.date;
      let matchStartTime = match.startTime;
      let homeName = match.homeName;
      let awayName = match.awayName;
      let matchNum = match.matchNum;
      let cornerNum = match.cornerNum;
      let matchTypeName = match.matchTypeName;
      let matchType = match.matchType;
      let matchProgress = match.matchProgress;
      let currentMin = match.currentMin;
      let homeScore = match.homeScore;
      let awayScore = match.awayScore;
      let firstHalfHomeScore = match.firstHalfHomeScore;
      let firstHalfAwayScore = match.firstHalfAwayScore;
      let dayOfWeek = match.dayOfWeek;
      aMatchNum.push(match.matchNum);
      let aTips = match.tips;
      let aFbBet = new Array<FbBetModel>();
      for (let tip of aTips) {
        let fbBet = tip.fbBet;
        let dividend = tip.dividend != -1 ? Util.getActualNumber(tip.dividend) : tip.dividend;
        let betType = fbBet.betType;
        let betAmount = Util.getActualNumber(tip.betAmount);
        let betItemOption = fbBet.itemOption;
        let winningMargin = fbBet.winningMargin;
        let winningMarginChanged = fbBet.winningMarginChanged;
        let odds = Util.getActualNumber(fbBet.odds).toString();
        let tipsId = tip.id;
        let createDate = tip.createDate;
        let note = tip.note;
        let image = tip.image;
        let isRefund = tip.isRefund;
        aFbBet.push(new FbBetModel(betType, betAmount, betAmountQuota, betItemOption, winningMargin,
          winningMarginChanged, odds, dividend, tipsId, createDate, note, image, isRefund))
      }
      let fbMatch = new FbMatch(matchId, matchNum, matchDate, matchStartTime, cornerNum,
        matchTypeName, matchType, matchProgress, currentMin, homeScore, awayScore, homeName,
        awayName, false, dayOfWeek, firstHalfHomeScore, firstHalfAwayScore);
      aFbPackageTip.push(new FbPackageTip(fbMatch, aFbBet));
    }

    let voucherCost = result.voucherCost;
    let voucherBalance = result.vouchers;
    let allowVoucher = result.allowVoucher;
    let canUseVoucher = result.voucherCost > 0;
    let allowRefund = result.allowRefund;
    let addCommentEnabled = result.addCommentEnabled;
    let fbBet = new FbBetModel(-1, -1, betAmountQuota, -1, "", false, "", tipsPackageDividend, -1, "", "", "0", false);
    let fbTipPrice = new FbTipPrice(purchased, tipsPackagePrice, voucherCost, canUseVoucher, allowVoucher, voucherBalance);
    let tipsterInfo = Util.convertTipsterInfoFromJson(tipsterInfoFromJson);
    let notesMsg = result.note != null ? result.note : "";
    let noteImage = result.image != null ? result.image : -1;
    let noteImageSrc = "";
    if (noteImage == 1) {
      noteImageSrc = Util.getImgUrl(Constants.Enum_ImageType.indexOf("TipsPackageNote"), tipsPackageId);
    }
    let isEditable = (tipsterInfoFromJson != null && tipsterInfoFromJson.id == loggedInUserId && !matchDayEnded);
    let fbNotes = new FbNotes(noteImageSrc, notesMsg, isEditable);
    let fbPersonalTipPackage = new FbPersonalTipsPackage(result.id, tipsterInfo, -1, new Array(fbBet), totalBetAmount, aMatchNum, !matchDayEnded,
      "", "", fbTipPrice, purchaseDate, fbNotes, curentBetAmount, buyerCount, allowRefund, addCommentEnabled, -1, "", "", -1);
    fbTipsPackageDetails.setValue(fbPersonalTipPackage, aFbPackageTip);
  }

  public static isApp(platform: Platform): boolean {
    // console.log("android: " + platform.is("android")
    //     + ", cordova: " + platform.is("cordova")
    //     + ", core: " + platform.is("core")
    //     + ", ios: " + platform.is("ios")
    //     + ", ipad: " + platform.is("ipad")
    //     + ", iphone: " + platform.is("iphone")
    //     + ", mobile: " + platform.is("mobile")
    //     + ", mobileweb: " + platform.is("mobileweb")
    //     + ", phablet: " + platform.is("phablet")
    //     + ", tablet: " + platform.is("tablet")
    //     + ", windows: " + platform.is("windows"));
    // console.log("userAgent: " + platform.userAgent());
    // return !platform.is("core") && !platform.is("mobileweb");
    //return document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1;
    return platform.is("cordova");
  }

  public static checkUpgrade(platform: Platform, serverVersion: string, clientVersion: string, translateService: TranslateService,
      alertCtrl: AlertController, navCtrl: NavController, iab: InAppBrowser, http: Http) {
        let  market = new Market();
    let upgradeStatus = this.getUpgradeStatus(serverVersion, clientVersion);
    if (upgradeStatus == "minor" || upgradeStatus == "major") {
      if (!this.isApp(platform)) {
        window.location.href = "index.html?t=" + new Date().getTime();
      } else {
        let upgradeMsgKey = "";

        if (upgradeStatus == "major") {
          // for major upgrade, user should be redirected to the app store/play store upgrade
          if (platform.is("ios")) {
            upgradeMsgKey = "updateiOSAppMarjorVersion";
          } else {
            upgradeMsgKey = "updateAndroidAppMarjorVersion";
          }
        } else if (upgradeStatus == "minor") {
          // for minor version, let the ionic deploy update the upgrade
          return;
          /*
          if (platform.is("ios")) {
            upgradeMsgKey = "updateiOSApp";
          } else {
            upgradeMsgKey = "updateAndroidApp";
          }
          */
        } else {
          return;
        }

        let cancelButton;
        if (upgradeStatus == "major") {
          cancelButton = {
            text: translateService.instant("cancel"),
            handler: () => {
              if (platform.is("ios")) {
                navCtrl.setRoot("StartUpPage", {}, { animate: true, direction: 'backforward' });
              } else {
                platform.exitApp();
              }
            }
          }
        } else {
          cancelButton = {
            text: translateService.instant("cancel"),
            role: "cancel"
          }
        }

        let confirm = alertCtrl.create({
          title: translateService.instant("confirm"),
          message: translateService.instant(upgradeMsgKey),
          enableBackdropDismiss: false,
          buttons: [
            cancelButton,
            {
              text: translateService.instant("ok"),
              handler: () => {
                if (platform.is("ios")) {
                  //window.location.href = "https://itunes.apple.com/us/app/jian-liao/id1168889376?l=zh&ls=1&mt=8";
                  // this.goToWeb("https://itunes.apple.com/us/app/jian-liao/id1168889376?l=zh&ls=1&mt=8", translateService, iab);
                  market.open("id1168889376");
                  navCtrl.setRoot("StartUpPage", {}, { animate: true, direction: 'backforward' });
                } else if (platform.is("android")) {
                  Util.canAccessGooglePlayStore(http).then(canAccess => {
                    if (canAccess) {
                      // window.location.href = "https://play.google.com/store/apps/details?id=com.kintips.kintips";
                      market.open("com.kintips.kintips");
                      navCtrl.setRoot("StartUpPage", {}, { animate: true, direction: 'backforward' });
                    } else {
                      let target = "_system";
                      let options = "location=no,zoom=no,toolbarposition=top,closebuttoncaption=close";
                      let downloadUrl = "http://www.kintips.com/download/kintips.apk";
                      iab.create(downloadUrl, target, options);
                    }
                  }).catch(err => {
                    console.log("Caught: " + err);
                  });


                }
              }
            }
          ]
        })

        confirm.present();

      }
    }

  }

  public static canAccessGooglePlayStore(http: Http): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      // check if Google Play Store is installed
      let appAvailability = new AppAvailability();
      appAvailability.check("com.android.vending").then(installed => {
        if (installed) {
          // check if Google Server is accessible
          let playStoreUrl = "https://play.google.com/store/apps";
          http.get(playStoreUrl).subscribe((resp: Response) => {
            resolve(resp.ok);
          },
          (err: Response) => {
            resolve(false);
          });
        } else {
          resolve(false);
        }
      }).catch(err => {
        resolve(false);
      })
    });
  }

  public static showWeekday(iWeekDay: number): string {
    //Util.getWeekday(fbMatchDay.dayOfWeek, this.translateService);
    if (iWeekDay == 1) {
      return "周日";
    } else if (iWeekDay == 2) {
      return "周一";
    } else if (iWeekDay == 3) {
      return "周二";
    } else if (iWeekDay == 4) {
      return "周三";
    } else if (iWeekDay == 5) {
      return "周四";
    } else if (iWeekDay == 6) {
      return "周五";
    } else if (iWeekDay == 7) {
      return "周六";
    }
  }

  public static getRaceNum(raceCards: Array<HorseRaceModel>, raceId: number): number {
    for (let raceCard of raceCards) {
      if (raceCard.raceId == raceId) {
        return raceCard.raceNum;
      }
    }
    return 0;
  }

  public static getRaceId(raceCards: Array<HorseRaceModel>, raceNum: number): number {
    for (let raceCard of raceCards) {
      if (raceCard.raceNum == raceNum) {
        return raceCard.raceId;
      }
    }
    return 0;
  }

  public static goToWebByBrowserTab(sUrl, browserTab: BrowserTab, platform: Platform, loadingCtrl: LoadingCtrlProvider,
      translateService: TranslateService, iab: InAppBrowser, reqCmd: number) {
    if (browserTab.isAvailable() && Util.isApp(platform)) {
      loadingCtrl.createCmdLoading(reqCmd);
      browserTab.openUrl(sUrl);
      loadingCtrl.dismissCmdLoading(reqCmd);
    } else {
      this.goToWeb(sUrl, translateService, iab);
    }
  }

  public static goToWeb(sUrl, translateService, iab) {
    // let win = window.open(sUrl, '_blank');
    // win.focus();
    let closeBtnTxt = translateService.instant("close");
    let target = "_blank";
    let options = "location=no,zoom=no,toolbarposition=top,closebuttoncaption=" + closeBtnTxt;
    iab.create(sUrl, target, options);
    // var CSS = ".inappbrowser-app-bar { background-color: red !important; } .inappbrowser-app-bar-inner { background-color: green !important; }";
    // iab.insertCSS({ code: CSS });
  }

  public static setThemeableBrowseStyle(themeableBrowser: ThemeableBrowser, url: string, title: string) {
    const options: ThemeableBrowserOptions = {
      statusbar: {
        color: '#000000'
      },
      toolbar: {
        height: 44,
        color: '#1f75d2'
      },
      title: {
        color: '#ffffffff',
        showPageTitle: false,
        staticText: title
      },
      closeButton: {
        wwwImage: 'assets/img/common/icon-header-close.png',
        wwwImageDensity: 2,
        align: 'right',
        event: 'closePressed'
      },

      backButtonCanClose: true
    }
    themeableBrowser.create(url, '_blank', options);
  }
  public static getWinningIndicatorImg(position, isOptOut = false) {
    let winningIndicatorUrl;
    if (position == 1) {
      if (isOptOut) {
        winningIndicatorUrl = "assets/img/horse/icon-medals-1-off.svg";
      } else {
        winningIndicatorUrl = "assets/img/horse/icon-medals-1.svg";
      }
    } else if (position == 2) {
      if (isOptOut) {
        winningIndicatorUrl = "assets/img/horse/icon-medals-2-off.svg";
      } else {
        winningIndicatorUrl = "assets/img/horse/icon-medals-2.svg";
      }
    } else if (position == 3) {
      if (isOptOut) {
        winningIndicatorUrl = "assets/img/horse/icon-medals-3-off.svg";
      } else {
        winningIndicatorUrl = "assets/img/horse/icon-medals-3.svg";
      }
    } else if (position == 4) {
      if (isOptOut) {
        winningIndicatorUrl = "assets/img/horse/icon-medals-4-off.svg";
      } else {
        winningIndicatorUrl = "assets/img/horse/icon-medals-4.svg";
      }
    }
    return winningIndicatorUrl;
  }

  public static convert4MoneyFormat(iNum: number): string {
    return iNum < 0 ? "-$" + (iNum * -1).toFixed(0) : "$" + iNum.toFixed(0);
  }

  public static validatePhoneNumber(phonePrefix, phoneNumber): string {
    let errMsgKey = "";
    if (phonePrefix == "86") {
      if (phoneNumber == null || phoneNumber == "" || isNaN(phoneNumber)) {
        errMsgKey = "alertMessageInvalidPhoneNumber_CN";
        console.log("validatePhoneNumber: 86 empty");
      } else if (phoneNumber.length != 11) {
        errMsgKey = "alertMessageInvalidPhoneNumber_CN";
        console.log("validatePhoneNumber: 86 length problem");
      } else if (phoneNumber.substring(0, 1) != "1") {
        errMsgKey = "alertMessageInvalidPhoneNumber_CN";
        console.log("validatePhoneNumber: 86 not started from 1");
      }
    } else if (phonePrefix == "852") {
      if (phoneNumber == null || phoneNumber == "" || isNaN(phoneNumber)) {
        errMsgKey = "alertMessageInvalidPhoneNumber_HK";
        console.log("validatePhoneNumber: 852 empty");
      } else if (phoneNumber.length != 8) {
        errMsgKey = "alertMessageInvalidPhoneNumber_HK";
        console.log("validatePhoneNumber: 852 length problem");
      } else if (phoneNumber.substring(0, 1) != "5" && phoneNumber.substring(0, 1) != "6" && phoneNumber.substring(0, 1) != "9") {
        errMsgKey = "alertMessageInvalidPhoneNumber_HK";
        console.log(phoneNumber.substring(0, 1) + "validatePhoneNumber: 852 not started from 5,6,9");
      }
    } else if (phonePrefix == "853") {
      if (phoneNumber == null || phoneNumber == "" || isNaN(phoneNumber)) {
        errMsgKey = "alertMessageInvalidPhoneNumber_MC";
        console.log("validatePhoneNumber: 853 empty");
      } else if (phoneNumber.length != 8) {
        errMsgKey = "alertMessageInvalidPhoneNumber_MC";
        console.log("validatePhoneNumber: 853 length problem");
      } else if (phoneNumber.substring(0, 1) != "6") {
        errMsgKey = "alertMessageInvalidPhoneNumber_MC";
        console.log("validatePhoneNumber: 853 not start from 6");
      }
    }
    return errMsgKey;
  }


  public static getImageFromUrl(http: Http, imageUrl: string): Observable<File> {
    return http
      .get(imageUrl, { responseType: ResponseContentType.Blob }).take(1).map((res: any) => {
        return res.blob();
      });
  }

  public static base64EncodeImageByCanvas(image: Blob) : Promise<string> {
    return new Promise((resolve, reject) => {
      var img = document.createElement('img');
      var me = this;

      img.onload = function () {

          let canvas = document.createElement('canvas'),
            ctx = canvas.getContext("2d");


          // destination canvas size
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          resolve(canvas.toDataURL());
      }

      img.onerror = function () {
        reject();
      }
      img.src = URL.createObjectURL(image);
    });
  }

  public static createImageFromBlob(image: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = function(event) {
        console.log("On Load");
        // return resolve(reader.result);
      }
      reader.onerror = function(event) {
        console.log("On Error");
      }
      reader.onabort = function(event) {
        console.log("On abort");
      }
      reader.onloadend = function(event) {
        console.log("On load end");
      }
      // reader.addEventListener("load", () => {
      //   return reader.result;
      // }, false);

      if (image) {
        console.log("ReadAsDataURL");
        reader.readAsDataURL(image);
      } else {
        console.log("Reject");
        reject()
      }
    });
  }

  public static share(platform: Platform, socialSharing: SocialSharing, actionSheetCtrl: ActionSheetController, sharingImg: string, sharingMsg: string) {
    if (Util.isApp(platform)) {

      if (platform.is("ios")) {
        // for ios whatsapp, we can display either image or text only. We prefer image over text
        if (sharingImg != null && sharingImg != "") {
          sharingMsg = "";
        }
      }

      socialSharing.share(sharingMsg, "", [sharingImg], "").then(response => {
        console.log(response);
      }, err => {
        console.log(err);
      })

    } else {
      let buttons = [{
        text: "Facebook",
        handler: () => {
          window.open("https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fwww.kintips.com&amp;src=sdkpreparse", "_blank");
        }
      }];

      if (platform.is("mobile")) {
        buttons.push({
          text: "WhatsApp",
          handler: () => {
            window.open("whatsapp://send?text=" + encodeURI(sharingMsg), "_blank");
          }
        },
          {
            text: "Line",
            handler: () => {
              window.open("line://msg/text/" + sharingMsg, "_blank");
            }
          })
      }

      let actionSheet = actionSheetCtrl.create({
        buttons: buttons
      });
      actionSheet.present();
    }
  }


  public static getHorseTipsPackageShareImgUrl(tipsPackageId: number, lang: string, userId: number) {
    return this.getShareImgUrl(ShareType.HorseTipsPackage, tipsPackageId, lang, userId);
  }

  public static getHorseInRaceShareImgUrl(tipsId: number, lang: string, userId: number) {
    return this.getShareImgUrl(ShareType.HorseInRace, tipsId, lang, userId);
  }

  public static getFbTipsPackageShareImgUrl(tipsId: number, lang: string, userId: number) {
    return this.getShareImgUrl(ShareType.FbTipsPackage, tipsId, lang, userId);
  }

  public static getShareImgUrl(shareType: number, tipsId: number, lang: string, userId: number) {
    let param = this.getShareImgName(userId, tipsId);
    return this.getServerUrl() + "iads/images/" + shareType + "/" + param + "." + lang + ".jpg";
  }

  public static getShareImgName(userId: number, tipsId: number): string {
    let param = CryptoJS.AES.encrypt((userId + "&" + tipsId), Constants.ENCRYPT_PASSPHASE).toString();
    return Util.replaceAll(param, "+", "_");
  }

  public static getClientVersion(platform: Platform, appVersion: AppVersion): Promise<string> {
    if (Util.isApp(platform)) {
      return appVersion.getVersionNumber();
    } else {
      return new Promise<string>((resolve, reject) => {
        resolve(Constants.VERSION);
      });
    }
  }

  public static getPersonalTipsPackageFromJson(result: any, fbTipsPackageDetails: FbTipsPackageDetails, userManagerProvider) {
    let purchased: boolean = result.purchased;
    fbTipsPackageDetails.fbPersonalTipsPackage.fbTipPrice.purchased = purchased;
    let aPackageTip = fbTipsPackageDetails.fbPackageTips;
    let aMatches = result.match;
    fbTipsPackageDetails.fbPersonalTipsPackage.buyerCount = result.buyerCount;
    let notesMsg = result.note != null ? result.note : "";
    let noteImage = result.image != null ? result.image : -1;
    let noteImageSrc = "";
    if (noteImage == 1) {
      noteImageSrc = Util.getImgUrl(Constants.Enum_ImageType.indexOf("TipsPackageNote"), result.id);
    }
    let matchDayEnded = result.matchDayEnded;
    let isEditable = (fbTipsPackageDetails.fbPersonalTipsPackage.tipsterInfo.id == userManagerProvider.getLoginUserId() && !matchDayEnded);
    let fbNotes = new FbNotes(noteImageSrc, notesMsg, isEditable);
    fbTipsPackageDetails.fbPersonalTipsPackage.fbNotes = fbNotes;
    for (let match of aMatches) {
      let matchId = match.id;
      for (let packageTip of aPackageTip) {
        let aResultTip = match.tips;
        if (packageTip.fbMatch.id == matchId) {
          let aTip = packageTip.fbBets;
          for (let resultTip of aResultTip) {
            for (let tip of aTip) {
              let resultFbBet = resultTip.fbBet;
              if (resultFbBet.betType == tip.betType) {
                tip.betAmount = Util.getActualNumber(resultTip.betAmount);
                tip.odds = Util.getActualNumber(resultFbBet.odds).toString();
                tip.betItemOption = resultFbBet.itemOption;
                tip.winningMargin = resultFbBet.winningMargin;
                break;
              }
            }
          }
        }
      }
    }
  }

  static isFirstClick4CannotPostTips(customStorageProvider: CustomStorageProvider): boolean {
    if (customStorageProvider.get<boolean>(Constants.STORAGE_KEY_FIRST_CLICK_4_CANNOT_POST_TIPS) == null) {
      return true;
    }
    return customStorageProvider.get<boolean>(Constants.STORAGE_KEY_FIRST_CLICK_4_CANNOT_POST_TIPS);
  }

  public static postTip(customStorageProvider: CustomStorageProvider, translateService: TranslateService, alertCtrl: AlertController,
      sMaxLossLimit: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (parseInt(sMaxLossLimit) <= -10000) {
        resolve(true);
      } else if (Util.isFirstClick4CannotPostTips(customStorageProvider)) {
        let confirmPublishAlert = alertCtrl.create({
          title: translateService.instant("confirm"),
          message: translateService.instant("preCannotPostTipsAlertMsg", {"maxLossLimit" : sMaxLossLimit}),
          buttons: [
            {
              text: translateService.instant("cancel"),
              role: 'cancel',
              handler: () => {
                resolve(false);
              }
            },
            {
              text: translateService.instant("ok"),
              handler: () => {
                customStorageProvider.set(Constants.STORAGE_KEY_FIRST_CLICK_4_CANNOT_POST_TIPS, false);
                resolve(true);
              }
            }
          ]
        });
        confirmPublishAlert.present();
      } else {
        resolve(true);
      }
    });
  }

  public static isVoucherAvailable(fbTipPrice: FbTipPrice): boolean {
    return fbTipPrice.tipPrice > 0 && (fbTipPrice.allowVoucher && fbTipPrice.canUseVoucher && ((fbTipPrice.voucherBalance - fbTipPrice.voucherCost) >= 0 ));
  }

  public static createDateFromString(sDateTime: string) {
    if (sDateTime.indexOf(":") == -1) {
      sDateTime += " 00:00:00";
    }

    let sFormattedDate = this.formatDateForApple(sDateTime);
    let saFormattedDate = sFormattedDate.split("T");

    let sDate = saFormattedDate[0];
    let saDate = sDate.split("-");
    let iYear = parseInt(saDate[0], 10);
    let iMonth = parseInt(saDate[1], 10) - 1;
    let iDay = parseInt(saDate[2], 10);

    let sTime = saFormattedDate[1];
    let saTime = sTime.split(":");
    let iHour = parseInt(saTime[0], 10);
    let iMin = parseInt(saTime[1], 10);
    let iSecond = parseInt(saTime[2], 10);

    let dDate = new Date(iYear, iMonth, iDay, iHour, iMin, iSecond);
    return dDate;
  }

  public static formatDateMonthDay(date:Date){
    let currMonth = date.getMonth() + 1;
    let strMonth = currMonth.toString();
    let currDate = date.getDate();
    let strDate = currDate.toString();
    if (currMonth < 10) {
      strMonth = "0" + strMonth;
    }
    if (currDate < 10) {
      strDate = "0" + strDate;
    }
    return strMonth + "-" + strDate;
  }

  public static formatDateForApple(date: string) {
    return date.replace(" ", "T");
  }

  public static getHkjcBanner() {
    if (FbConfig.DEBUG) {
      return "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/video/hkjcBanner.jpg";
      //return "https://cdn.kintips.com:" + FbConfig.PRD_HTTPS_PORT + "/iads/images/" + imageType + "/" + imageId + ".jpg";
    } else {
      return "https://cdn.kintips.com:" + FbConfig.PRD_HTTPS_PORT + "/video/hkjcBanner.jpg";
    }
  }

  public static convertDate2DDMMYY(sDate: string, isShowYY: boolean = true) {
    let alDate = sDate.split("-");
    return alDate[2] + "/" + alDate[1] + (isShowYY ? ("/"  + alDate[0].substring(2,4)) : "");
  }
  public static getRaceTrack(raceTrack: number) {
    switch (raceTrack) {
      case RaceTrack.RaceTrack_AllWeather:
        return "";
      case RaceTrack.RaceTrack_A:
        return "A";
      case RaceTrack.RaceTrack_A2:
        return "A+2";
      case RaceTrack.RaceTrack_A3:
        return "A+3";
      case RaceTrack.RaceTrack_B:
        return "B";
      case RaceTrack.RaceTrack_B2:
        return "B+2";
      case RaceTrack.RaceTrack_B3:
        return "B+3";
      case RaceTrack.RaceTrack_C:
        return "C";
      case RaceTrack.RaceTrack_C3:
        return "C+3";
      case RaceTrack.RaceTrack_NA:
        return "";
      case RaceTrack.RaceTrack_NB:
        return "NB";
      case RaceTrack.RaceTrack_NB2:
        return "NB2";
      default:
        return "";
    }
  }

  public static getBarrierTrialDistanceShort(raceDistance: number): number {
    return Util.getActualNumber(raceDistance);
  }

  public static getRaceCourseDisplayed(iRaceCourse: number, iTrack: number, iRaceDistance: number, isBarrierTrial: boolean = false, isAllWeather?: boolean,
    sBarrierTrialRaceDistance?: number): RaceCourseDisplayed {
  let raceCourseDisplayed:RaceCourseDisplayed = new RaceCourseDisplayed();
  raceCourseDisplayed.RaceCourse = iRaceCourse;
  let isRaceCourseShatin = iRaceCourse == RaceCourse.RaceCourse_Shatin;

  if (isBarrierTrial == true) {
    raceCourseDisplayed.raceDistanceDisplayed = Math.floor(Util.getBarrierTrialDistanceShort(sBarrierTrialRaceDistance)).toString();
    raceCourseDisplayed.raceDistanceDisplayedFull = sBarrierTrialRaceDistance.toString();
  } else {
    raceCourseDisplayed.RaceDistance = iRaceDistance;
    raceCourseDisplayed.Track = iTrack;
    isAllWeather = iTrack == Enums.RaceTrack.AllWeatherTrack;
    raceCourseDisplayed.raceDistanceDisplayed = Enums.RaceDistance1[iRaceDistance].substring(3, 5);
    raceCourseDisplayed.raceDistanceDisplayedFull = Enums.RaceDistance1[iRaceDistance].substring(3, 7);
  }
  if (isRaceCourseShatin) {
    if (isAllWeather) {
      raceCourseDisplayed.color = "#FFFFFF";
      raceCourseDisplayed.backgroundColor = "#8A5D3B";
    } else {
      raceCourseDisplayed.color = "#007F80";
      raceCourseDisplayed.backgroundColor = "";
    }
  } else if (iRaceCourse == RaceCourse.RaceCourse_CongHua) {
    raceCourseDisplayed.color = "#000000";
    raceCourseDisplayed.backgroundColor = "#F8ECFF";
  } else {
    raceCourseDisplayed.color = "#00A551";
    raceCourseDisplayed.backgroundColor = "";
  }
  if (isAllWeather && isRaceCourseShatin) {
    raceCourseDisplayed.raceCourseShortForm = Enums.RaceCourseShortForm[Enums.RaceCourseShortForm.ShatinAllWeatherShortForm];
  } else {
    raceCourseDisplayed.raceCourseShortForm = Enums.RaceCourseShortForm[iRaceCourse];
  }
  if (isAllWeather) {
    raceCourseDisplayed.TrackEng = "All Weather";
  } else {
    raceCourseDisplayed.TrackEng = "Turf Track";
  }
  return raceCourseDisplayed;
  }

  public static getYoutubeUrl(videoId: string){
    return 'https://www.youtube.com/embed/' + videoId;
  }

  public static getFormattedOdd(oddValue: number) {
    let result = null;
    if (oddValue != null) {
      if (oddValue < 10) {
        if(oddValue % 1 > 0){
          result =  Math.floor(oddValue * 10) / 10;
        } else {
          result = oddValue.toFixed(1);
        }
      } else {
        result = Math.floor(oddValue);
      }
    }
    return result;
  }

  public static getSpeedArticleBanner() {
    return "assets/img/common/speed_article_pro_banner.png";
  }

  public static getJSONfromUrl(url: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      fetch(url).then(function(response) {
        if (!response.ok) {
          reject();
        }
        return response.json();
      }).then(function(myJson) {
        resolve(myJson);
      });
    });
  }

  public static isNotNullAndDefined(object : any) {
    return object !== null && object !== undefined;
  }

}






// WEBPACK FOOTER //
// ./src/util/Util.ts